<template>
  
  <div ref="scroll-tracker-root">
    <slot></slot>
  </div>

</template>
<script>
export default {
  name: "scroll-tracker",
  data() {
    return {
      observer: null,
      root: null,
      sections: [],
      section_changes: [],
      update_count: 0,
    }
  },
  methods: {
    intersectionObserved(observings_entries){
      // this is a callback function called whenever during scrolling whenever one of the sections visibility (intersection_ratio) changes past a threshold

      // process all observation updates
      for(let observings_entry of observings_entries){
        let section = this.sections.find(s => s.element == observings_entry.target);
        section.intersection_ratio = observings_entry.intersectionRatio;
      }

      // find max intersection_ratio
      let max_intersection_ratio = Math.max(...this.sections.map(s => s.intersection_ratio));

      // updated all sections visibility
      // a section is visible if its intersection_ratio == 1 or if it has the highest intersection_ratio
      for(let section of this.sections){
        let visible = section.intersection_ratio == max_intersection_ratio || section.intersection_ratio == 1;
        section.visible = visible ? 1 : 0;

        if(section.visible){
          let parent = section.parent;
          while(parent){
            parent.visible = 2;
            parent = parent.parent;
          }
        }
      }

    },
    initialize(){
      this.root = this.$refs['scroll-tracker-root'];

      let observeroptions = {
        // rootMargin: '-60px', // outermost 60 pixels are ignored to account for floating header
        threshold: [0, 0.2, 0.4, 0.6, 0.8, 1], // percentages at which to call the callback function
      };
      this.observer = new IntersectionObserver(this.intersectionObserved, observeroptions);
      this.processSectionChanges();
    },
    addSection(component){
      // create selection entry
      let section = {
        element: component.$el,
        name: component.name,
        id: component.$el.id,
        visible: 0,
        intersection_ratio: 0,
        depth: 0,
        parent: null,
        show: component.show,
      };
      // add change entry to be processed once possible
      this.section_changes.push({
        action: 'add',
        section: section,
      });
      this.processSectionChanges();
    },
    removeSection(component){

      // find section entry for the component
      let section = this.sections.find(s => s.element == component.$el);
      // add change entry to be processed once possible
      this.section_changes.push({
        action: 'remove',
        section: section,
      });
      this.processSectionChanges();
    },
    setSectionShown(component, show){

      // find section entry for the component
      let section = this.sections.find(s => s.element == component.$el);
      // add change entry to be processed once possible
      section.show = show;
      //this.processSectionChanges();
      this.update_count++;
    },
    processSectionChanges(){
      // check if observer exists, without it leave queue
      if(this.observer){
        // process each queue entry
        for(let { action, section } of this.section_changes){
          
          if(action == 'add'){
            // add to selections and register observer
            this.sections.push(section);
            this.observer.observe(section.element);
          }
          if(action == 'remove'){
            // remove from selections and deregister observer
            let index = this.sections.indexOf(section);
            this.sections.splice(index, 1);
            this.observer.unobserve(section.element);
          }
        }
        // clear change queue
        this.section_changes = [];
        // sort by actual vertical position // depricated
        // this.sections.sort((a,b) => a.element.offsetTop - b.element.offsetTop);
        this.orderSectionsAndStructure();
      }
    },
    orderSectionsAndStructure(){
      
        // sort section entries by element position in DOM
        this.sections.sort((a,b) => {
          let relationship = a.element.compareDocumentPosition(b.element);
          if(relationship & 0b00000010) // a before b
            return 1;
          if(relationship & 0b00000100) // a after b
            return -1;
          
          return 0;
        });

        // determine sturcture
        let depth = 0;
        let parent_stack = [{element:this.root}];
        for(let i = 1; i < this.sections.length; i++){
          let a_b_relationship = this.sections[i-1].element.compareDocumentPosition(this.sections[i].element);
          let parent_b_relationship = parent_stack[0].element.compareDocumentPosition(this.sections[i].element);
          if(a_b_relationship & 0b00010000){ // a contains b
            depth += 1;
            parent_stack.unshift(this.sections[i-1]);
            // this.sections[i].parent = this.sections[i-1] // this will only link the first child to a parent
          }
          while(! (parent_b_relationship & 0b00010000) && parent_stack.length > 1 ){ // parent not contains b
            depth -= 1;
            parent_stack.shift();
            parent_b_relationship = parent_stack[0].element.compareDocumentPosition(this.sections[i].element);
          }

          // decidied not to use this approach as it forms gap in the list (as in active parent, incative children and then active visible child)
          this.sections[i].parent = parent_stack.length > 1 ? parent_stack[0] : null; // this will link all chrisdren to a parent

          this.sections[i].depth = depth;
        }
    },
  },
  mounted() {
    this.initialize();
  },
  beforeDestroy(){
    this.observer.disconnect();
    this.observer = null;
  },
};
</script>
<style scoped lang="scss">
  @import "../../assets/scss/theme.scss";

</style>
